import stepper from "./stepper.component";

const stepperModule = angular
  .module("app.components.stepper", [])
  .component("stepper", stepper);

export default stepperModule;



// WEBPACK FOOTER //
// ./src/components/stepper/stepper.module.js